"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimerPinComponentSchema = void 0;
const zod_1 = require("zod");
const base_pin_component_1 = require("./base-pin-component");
const setting_1 = require("../setting");
const TimerSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    seconds: zod_1.z.number().optional(),
    playSound: zod_1.z.boolean().optional(),
    shadow: setting_1.ShadowSettingKeySchema,
    borderSize: zod_1.z.number().optional(),
    borderColor: zod_1.z.string().optional(),
}));
exports.TimerPinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('TIMER'),
    settings: TimerSettingsSchema,
}));
//# sourceMappingURL=timer-pin-component.js.map